import React from 'react';
import './About.css';
const About = () => {
    return (
        <div>
            <h2 className='about-h2'>History of Kiddo Toy Storage Solution</h2>
            <div className='about-h6'>
                <h6>
                    Kiddo Toy Storage Solution has a long way to go to support storage solution for the kids toy's Industries.
                    Here we provide all kinds of toy storage spaces, with a smart delivery and stock application. We have a wide space with propert
                    air circulation system and also have enough vehicles for delivery and storing products.
                    we have a good number of efficient workers and a bunch of software engineer to maintain storage data.

                </h6>
            </div>
        </div>
    );
};

export default About;